import { screens } from 'tailwindcss/defaultTheme';
import dynamicHeight from './src/plugins/dynamicHeight';
import animated from 'tailwindcss-animated';

/** @type {import('tailwindcss').Config} */
export default {
  mode: 'jit',
  important: true,
  darkMode: 'class',
  content: ['./src/**/*.{js,ts,jsx,tsx}'],
  plugins: [dynamicHeight, animated],
  theme: {
    extend: {
      colors: {
        'brand-green-light': '#F9FAE0',
        'brand-green-hover': '#EBF163',
        'brand-green': '#d5dc2e',
        'brand-brown-light': '#E1DCD8',
        'brand-brown': '#9C8B7E',
        'red-7': '#cf1322',
        'gray-3': '#f5f5f5',
        'gray-7': '#8c8c8c',
        'gray-8': '#595959',
        'gray-10': '#262626',
      },
      screens: {
        ...screens,
        lg: '1440px',
        md: '1160px',
        sm: '744px'
      },
      keyframes: {
        scroll: {
          '0%': { transform: 'translateX(100%)' },
          '100%': { transform: 'translateX(-100%)' },
        },
      },
      animation: {
        scroll: 'scroll 10s linear infinite',
      },
      boxShadow: {
        'primary': '-2px 0px 20px 1px rgba(0, 0, 0, 0.2)',
      }
    },
  },
};
